// Home.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaLocationArrow } from 'react-icons/fa';
import { IoLocationSharp } from "react-icons/io5";
import { ClimbingBoxLoader } from 'react-spinners';


 export const Home = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [minRent, setMinRent] = useState(0);
  const [maxRent, setMaxRent] = useState(10000);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); // Set loading to true when starting API request
    // Fetch data from your API with filter parameters
    fetch(`https://pgdost.onrender.com/api/rooms?minRent=${minRent}&maxRent=${maxRent}`)
      .then((response) => response.json())
      .then((data) => {
        setRooms(data.rooms);
        setLoading(false); // Set loading to false when data is received
      })
      .catch((error) => {
        console.error('Error fetching rooms:', error);
        setLoading(false); // Set loading to false in case of an error
      });
  }, [minRent, maxRent]);

  const handleViewMore = (roomId) => {
    // Redirect to the room details page with the room ID
    navigate(`/room/${roomId}`);
  };
  const handleroom = () => {
    navigate('/createpost')
  }

  // Redirect to login if the user is not authenticated
  useEffect(() => {
    if (localStorage.getItem('email') == null && localStorage.getItem('password') == null) {
      navigate('/login');
    }
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen font-sans">
      {/* Featured Room Section */}
   

      {/* Available Rooms Section */}
      <section className="  py-12 bg-white-300 py-12">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Available Rooms</h2>
          {/* Room Filters */}
          <div className="flex flex-col items-center mt-6">
            <label className="mb-2 text-lg">Min Rent:</label>
            <input
              type="range"
              min="0"
              max="20000"
              value={minRent}
              onChange={(e) => setMinRent(e.target.value)}
              className="w-3/4 sm:w-1/2 lg:w-1/3 xl:w-1/4 border p-1"
            />
            <span className="text-center mb-2">₹{minRent}</span>
            <label className="mb-2 text-lg">Max Rent:</label>
            <input
              type="range"
              min="0"
              max="20000"
              value={maxRent}
              onChange={(e) => setMaxRent(e.target.value)}
              className="w-3/4 sm:w-1/2 lg:w-1/3 xl:w-1/4 border p-1"
            />
            <span className="text-center">₹{maxRent}</span>
          </div>

          {/* Room Listings */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 mt-8">
          {loading ? (
          <div className="w-full flex items-center justify-center h-64 sm:ml-96  ">
          {/* Center the loading spinner */}
          
          <ClimbingBoxLoader color="rgba(54, 89, 214, 1)" size={29} />
        </div>
        ) : (
            
            
            rooms.map((room) => (
              <div
                key={room._id}
                className="w-full max-w-md bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 mx-auto transition-transform transform hover:scale-105"
              >
                <a href="#">
                  <img
                    className="w-full h-40 object-cover rounded-t-lg"
                    src={room.photos[0]} // Use the base64 string directly
                    alt="product image"
                  />
                </a>
                <div className="px-6 py-4">
                  <a href="#">
                    <h5 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">
                      {room.pgName}
                    </h5>
                  </a>
                  {/* Room Contact Buttons */}
                  <div className="flex items-center mt-2.5 mb-4 space-x-2">
                  <IoLocationSharp />
                  <span className="font-bold text-gray-500">
                    {room.locationurl.length > 20
                      ? room.locationurl.substring(0, 20) + '...'
                      : room.locationurl}
                  </span>
                  </div>
                  {/* Room Details and Price */}
                  <div className="flex items-center justify-between">
                    <span className="text-3xl font-bold text-gray-900 dark:text-white">
                      ₹{room.roomRent}/month
                    </span>
                    <a
                      href="#"
                      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      onClick={() => handleViewMore(room._id)}
                    >
                      See More <FaArrowRight className="ml-2" />
                    </a>
                  </div>
                </div>
              </div>
              ))
              )}
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      

      {/* Call to Action Section */}
      <section className="bg-blue-600 text-white py-12 ">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to List Your Room?</h2>
          <p className="text-lg mb-8">Help others find their perfect roommate by listing your room now!</p>
          <div className="flex justify-center items-center">
            <button className="bg-white text-blue-600 hover:bg-green-300 font-bold py-3 px-6 rounded" onClick={handleroom}>
              List Your Room
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};


